import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import style from './index.module.css';

export const Censored = () => {
  const { t } = useTranslation();

  const history = useHistory();

  useEffect(() => {
    history.replace('/');
    // eslint-disable-next-line
  }, []);

  return <div className={style.tip}>{t('Censored.15pipi7')}</div>;
};
